import { callAxios } from "plugin/call.axios"

export const GET_ACTIVITY = (filter:any) => {
    return callAxios({
        url: '',
        method: 'POST',
        data: filter
    })
}